import script from "./CaptionSettingsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionSettingsBar.vue?vue&type=script&setup=true&lang=js"

import "./CaptionSettingsBar.vue?vue&type=style&index=0&id=d8522e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8522e40"]])

export default __exports__